import styled from 'styled-components';

const LeftH5 = styled.div`
	margin-right: 10px;
	color: #182026;
    font-weight: 600;
    line-height: 19px;
    font-size: 16px;
    display: inline-block;
`;

const RightH5 = styled.div`
	margin-left: 10px;
	color: #182026;
    font-weight: 600;
    line-height: 19px;
    font-size: 16px;
    display: inline-block;
`;

interface IInlineListProps {
	label: JSX.Element;
	labelRight?: boolean;
}

// TODO pass props to styled component to avoid duplicate components
const InlineList: React.SFC<IInlineListProps> = ({label, labelRight, children}) => (
	<div>
		{labelRight ? (
			<RightH5>{label}</RightH5>
		) : (
			<LeftH5>{label}</LeftH5>
		)}
		{children}
	</div>
);

export default InlineList;



// WEBPACK FOOTER //
// ./src/common/fragments/InlineList.tsx